import React, { useState } from 'react';
import { Grid, Typography, OutlinedInput } from '@mui/material';
import RoundButton from '../components/roundButton';
import SummaryModal from '../components/summaryModal';
import HttpService from '../../services/http.service';
import CartModal from '../components/cartModal';
import Chat from '../components/chat';
import TextModal from '../components/textModal';
import axios from 'axios';
import '../assets/css/right.css';
import {
  addToCartDataLayer,
  whereToBuyDataLayer,
  requestQuoteDataLayer,
  viewSummarySheetDataLayer
} from '../../services/pdfDataLayer';

import { getManifoldOrderSummarySteps } from '../../services/virtualEngineerIntegrationService';

import { createPartNumberListofSegments } from '../../services/virtualEngineerIntegrationService';

import {
  getUniquePartIdentifierforManifold,
  create,
  uniqueCodeTemplate
} from '../../services/bomService';

import { getStep, getPartNumberString } from '../../services/tactonService';

import {
  getContentSyndicationData,
  gatewayAPI
} from '../../services/contentSyndicationService';

import { postSessionData } from '../../services/sessionDataService';

import LiveChatCountries from '../../models/LiveChatCountries';

import { GetLangId } from '../../services/commonService';

import { getAPIBaseURL, getAPIKey } from '../../services/config';

import RequestQuoteModal from '../components/requestQuoteModal';

let wcToken = '',
  wcTrustedToken = '';

const RightSection = props => {
  const [openModal, setOpenModal] = useState(false);
  const {
    contactus,
    dataItems,
    sessionDataItems,
    lang,
    priceLeadTime,
    hoseAssemblyPrice,
    uniquePartIdentifier,
    handleUniquePartNumber,
    activeTab,
    config
  } = props;
  const [displayPartNumber, setDisplayPartNumber] = useState();
  const [txt_quantity, set_txt_quantity] = useState(1);
  const [addToCartData, setAddToCardData] = useState();
  const [openCartModal, setOpenCartModal] = useState(false);
  const [orderSummarySteps, setOrderSummarySteps] = useState();
  const [openTextModal, setOpenTextModal] = useState(false);
  const [modalContent, setModalContent] = useState();
  const [miniQuoteCartResponse, setMiniQuoteCartResponse] = useState();
  const [cartResponse, setCartResponse] = useState();
  const [showRequestQuote, setShowRequestQuote] = useState(false);
  const [productImage, setProductImage] = useState();
  let localUniquePartIdentifier = uniquePartIdentifier;

  const CartType = {
    None: 'None',
    Shop: 'Shop',
    Quote: 'Quote'
  };

  const handleRequestQuote = async () => {
    try {
      props.isLoading(true);

      if (sessionDataItems.contentSyndication != null) {
        postContentSyndication(false);
      }

      requestQuoteDataLayer(
        sessionDataItems,
        getPartNumberString(dataItems),
        txt_quantity
      );

      if (dataItems.isNormalProduct) {
        sessionDataItems.partNumber = getPartNumberString(dataItems);
      } else {
        var OrderCodeComplete = dataItems?.infoGroup?.orderCodeComplete?.value;
        sessionDataItems.partNumber = OrderCodeComplete.split('~')[0];
      }

      if (sessionDataItems.contentSyndication != null) {
        if (sessionDataItems.contentSyndication.requestquote.url != '') {
          let content = await gatewayAPI(
            sessionDataItems.contentSyndication.requestquote.url,
            sessionDataItems.partNumber
          );

          setOpenTextModal(true);
          setModalContent(content);
          return;
        }
      }

      await CallGuestIdentity();

      sessionDataItems.bomRefId = null;
      let result = await createBom(sessionDataItems);
      props.isLoading(false);
    } catch (error) {
      console.log(error);
      props.isLoading(false);
    }
  };

  const CallGuestIdentity = async () => {
    var env = getEnvironment();

    let wcTokenCookieName = env + 'WCToken';
    let wcTrustedTokenCookieName = env + 'WCTrustedToken';

    wcToken = getCookie(wcTokenCookieName);
    wcTrustedToken = getCookie(wcTrustedTokenCookieName);

    // for (var i = 1; i <= cookies.length - 1; i++) {
    //   if (
    //     cookies[i].includes(strenv + 'WCToken') &&
    //     cookies[i].split('=').length > 1
    //   )
    //     wcToken = cookies[i].split('=')[1];
    //   if (
    //     cookies[i].includes(strenv + 'WCTrustedToken') &&
    //     cookies[i].split('=').length > 1
    //   )
    //     wcTrustedToken = cookies[i].split('=')[1];
    // }

    if (wcToken == '' && wcTrustedToken == '') {
      var storeId = sessionDataItems.storeId;
      var response = await HttpService.getAll(
        `Cart/GetGuestIdentity?storeId=${storeId}`
      );
      let guestInfo = response.data;
      wcToken = guestInfo.wcToken;
      wcTrustedToken = guestInfo.wcTrustedToken;
      setCookie(wcTokenCookieName, wcToken);
      setCookie(wcTrustedTokenCookieName, wcTrustedToken);
      // if (
      //   URL.includes('dev') ||
      //   URL.includes('test') ||
      //   URL.includes('preview') ||
      //   URL.includes('localhost')
      // ) {
      //   document.cookie =
      //     'test_WCToken=' + guestInfo.wcToken + ';domain=.parker.com;path=/';
      //   document.cookie =
      //     'test_WCTrustedToken=' +
      //     guestInfo.wcTrustedToken +
      //     ';domain=.parker.com;path=/';
      // } else {
      //   document.cookie =
      //     'prod_WCToken=' + guestInfo.wcToken + ';domain=.parker.com;path=/';
      //   document.cookie =
      //     'prod_WCTrustedToken=' +
      //     guestInfo.wcTrustedToken +
      //     ';domain=.parker.com;path=/';
      // }
    }

    await addtoQuote();
  };

  const addtoQuote = async () => {
    let product = {
      catEntryId: sessionDataItems.productId,
      quantity: txt_quantity.toString()
    };

    const headers = {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': getAPIKey(),
      wcToken: wcToken,
      WCTrustedToken: wcTrustedToken
    };

    let response = await axios.post(
      `${getAPIBaseURL()}/pdp/store/${
        sessionDataItems.storeId
      }/component/quote/createQuote?langId=${GetLangId(
        sessionDataItems.language
      )}&catalogId=14051`,
      product,
      { headers: headers }
    );

    if (response) {
      let cookieName = getEnvironment() + 'eConfigPartNumber';
      let cookieValue = getCookie(cookieName);
      if (cookieValue) {
        cookieValue =
          cookieValue +
          ',' +
          response.data.orderItemId[0] +
          '||' +
          sessionDataItems.partNumber;
      } else {
        cookieValue =
          response.data.orderItemId[0] + '||' + sessionDataItems.partNumber;
      }
      setCookie(cookieName, cookieValue);

      setCartResponse(response.data);
      await getProductImage();
      let miniQuoteResponse = await getMiniQuoteData();
      if (miniQuoteResponse) {
        setMiniQuoteCartResponse(miniQuoteResponse);
      }
      parkerUI.updateCartOrQuote('quote-update');
      setShowRequestQuote(true);
    }
  };

  const getMiniQuoteData = async () => {
    let langId = GetLangId(sessionDataItems.language);

    const headers = {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': getAPIKey(),
      wcToken: wcToken,
      WCTrustedToken: wcTrustedToken
    };
    try {
      let res = await axios.get(
        `${getAPIBaseURL()}/rfq/${
          sessionDataItems.storeId
        }/component/cart/miniquotecart/details?langId=${langId}`,
        { headers: headers }
      );

      return res.data;
    } catch (error) {
      console.log(error);
    }
  };

  const getProductImage = async () => {
    const headers = {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': getAPIKey()
    };
    let productName;

    try {
      let productUrl = sessionDataItems.productUrl?.split('?')[0];
      if (productUrl) {
        let urlParts = productUrl.split('/');
        productName = urlParts.pop();
      }

      let response = await axios.get(
        `${getAPIBaseURL()}/product-list/store/${
          sessionDataItems.storeId
        }/component/product-list/productlistdetailbyseo/${productName}?langId=-1&catalogId=14051`,
        { headers: headers }
      );

      if (response) {
        setProductImage(response.data?.thumbnails[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const addToCart = async (partNum, sessionId) => {
    if (sessionDataItems.option == '100') {
      let price = 0;
      let currenySymbol = '';
      let UnitPriceValue = '0.00';
      let currencyCode = '';
      let pchonnectURL = '';
      if (priceLeadTime != null) {
        currenySymbol = priceLeadTime.currencySymbol;
        price = priceLeadTime.priceAmt;
        if (price > 0) UnitPriceValue = price.toString();
        currencyCode = priceLeadTime.currencyCode;
      }
      pchonnectURL =
        sessionDataItems?.phConnect?.url + '/CRM/OrderEntry/ConfigAdd.asp';
      var formAction = pchonnectURL;
      var bodyFormData = new URLSearchParams();

      bodyFormData.append('Ticket', sessionDataItems?.ticket);
      bodyFormData.append('Token', sessionDataItems?.token);
      bodyFormData.append('Source', sessionDataItems?.manufacturingDivision);
      bodyFormData.append('ModelPartID', sessionDataItems?.configModel);
      bodyFormData.append('UnitPriceValue', UnitPriceValue);
      bodyFormData.append('ManufacturerPartID', partNum);
      bodyFormData.append('ConfiguratorControlAttributes', getControls());
      bodyFormData.append('CurrencyCode', currencyCode);
      bodyFormData.append('CurrencySymbol', currenySymbol);
      bodyFormData.append('BasePriceClass', 'List');
      bodyFormData.append('ModelText', sessionDataItems?.seriesName);
      bodyFormData.append('OpenerID', '');
      bodyFormData.append('eConfigurator', 'TACTON');

      try {
        await axios.post(formAction, bodyFormData);
        document.location.href = pchonnectURL;
        props.isLoading(false);
      } catch {
        props.isLoading(false);
      }
    } else {
      try {
        let url = await getCartUrl(partNum, sessionId);
        !url && setOpenCartModal(true);
        props.isLoading(false);
      } catch {
        props.isLoading(false);
      }
    }
  };

  const getControls = () => {
    var parts = allPartNumbers();

    var options = [];
    var total = 0;

    for (var i = 0; i < parts.length; i++) {
      var fieldLength = parts[i].value.length;
      var fieldPos = i + 1;
      var finalData = `000000000${parts[i].description.padEnd(
        50,
        ' '
      )}000${fieldLength.toString().padStart(3, '0')}${fieldPos
        .toString()
        .padStart(3, '0')}${parts[i].value}`.padEnd(188);
      options.push(`[${finalData}]`);
    }

    return options.join('');
  };

  const getCartUrl = async (partNum, sessionId) => {
    let attributes = {};
    let guestInfo = null;
    let quantity = txt_quantity;
    var currentStep = dataItems?.tactonModel?.steps?.filter(
      x => x.current == true
    );

    dataItems?.uiGroup?.members?.map(ele => {
      attributes[ele.description] = ele.valueDescription;
    });

    //*********FOR GOLD CUP************
    // if (Object.keys(attributes).length == 0) {
    //   let infoGroup = step.rootGroup.members.filter(
    //     x => x.properties !== undefined && x.properties['info_group'] == 'yes'
    //   );
    //   rootMembers = step.rootGroup.members.filter(x => !infoGroup.includes(x));
    // }

    let key = await createXMLReference(
      attributes,
      partNum,
      partNum,
      sessionDataItems?.manufacturingDivision
    );

    var carttype = 'quote';
    if (sessionDataItems?.cartType == CartType.Shop) carttype = 'shop';

    if (carttype == 'quote') {
      var url = `${sessionDataItems.cartUrl}${key}&cartType=${carttype}&quantity=${quantity}`;
      if (dataItems?.tactonModel?.steps.length < 4) {
        var refId = await create(
          dataItems,
          sessionDataItems,
          sessionId,
          partNum,
          uniquePartIdentifier
        );
        url += `&refId=${refId}`;
      }

      window.open(url, '_blank');
      return url;
    } else if (carttype == 'shop') {
      var cookies = document.cookie.split(';');
      var wcToken = '';
      var wcTrustedToken = '';
      var strenv = getEnvironment();
      for (var i = 1; i <= cookies.length - 1; i++) {
        if (
          cookies[i].includes(strenv + 'WCToken') &&
          cookies[i].split('=').length > 1
        )
          wcToken = encodeURIComponent(cookies[i].split('=')[1]);
        if (
          cookies[i].includes(strenv + 'WCTrustedToken') &&
          cookies[i].split('=').length > 1
        )
          wcTrustedToken = encodeURIComponent(cookies[i].split('=')[1]);
      }
      if (wcToken == '' && wcTrustedToken == '') {
        var storeId = sessionDataItems.storeId;
        var response = await HttpService.getAll(
          `Cart/GetGuestIdentity?storeId=${storeId}`
        );
        guestInfo = response.data;
        wcToken = encodeURIComponent(guestInfo.wcToken);
        wcTrustedToken = encodeURIComponent(guestInfo.wcTrustedToken);
        if (
          URL.includes('dev') ||
          URL.includes('test') ||
          URL.includes('preview') ||
          URL.includes('localhost')
        ) {
          document.cookie =
            'test_WCToken=' + guestInfo.wcToken + ';domain=.parker.com;path=/';
          document.cookie =
            'test_WCTrustedToken=' +
            guestInfo.wcTrustedToken +
            ';domain=.parker.com;path=/';
        } else {
          document.cookie =
            'prod_WCToken=' + guestInfo.wcToken + ';domain=.parker.com;path=/';
          document.cookie =
            'prod_WCTrustedToken=' +
            guestInfo.wcTrustedToken +
            ';domain=.parker.com;path=/';
        }
      }

      // wcToken =
      //   '10090008%252C9PexsIdJGFRbQwuy7L5Gzaq%252F5afddaNh6iwCG5Tydu%252B65PAnztsBLgmcf1sPDotVSkAA2TWeriEvJ0hxAw%252B1MKMcVW91yzhQ%252FyxCkQRGMhCjcTyYVHkqcmDDCXxGETfKMHTNwU3qvLFZehDqN8uwZUAAX2xy%252FXxo5B%252F5FvwCUroFT1uoQhzkj8itf7fZfHtlNWXGVYIgszld0E%252FWJLYU1FJZaNFtD1fPlUNZYtXe%252FZRIdysOv%252F30qoU74jytY96R';
      // wcTrustedToken =
      //   '10090008%252CMTqiLyeztRoAaac2%252BjQgj5kuL7Bi%252B1Pr7eXe0QceiBs%253D';
      //key = "b1ebc13b-1ea0-487d-968d-90cd6a4c2c90";

      var storeId = sessionDataItems.storeId;
      var catalogId = '14051';
      var result = await HttpService.getAll(
        `Cart/GetAddtoCartPrice?wcToken=${wcToken}&wcTrustedToken=${wcTrustedToken}&storeId=${storeId}&cartType=${carttype}&key=${key}&catalogId=${catalogId}&quantity=${quantity}`
      );

      var minicartDetails = await HttpService.getAll(
        `Cart/GetMiniCartDetails?wcToken=${wcToken}&wcTrustedToken=${wcTrustedToken}&storeId=${storeId}`
      );

      var items = [];
      var totalPrice = '';

      if (minicartDetails.data != '') {
        totalPrice = minicartDetails.data.Subtotal;
        if (minicartDetails.data.orderItems.length > 0) {
          minicartDetails.data.orderItems.forEach(orderItem => {
            var hierarchy = orderItem.partCategoryHierarchy.split('#');
            items.push({
              item_name: orderItem.partName,
              item_id: orderItem.itemId,
              affiliation: 'N/A',
              quantity: Number(orderItem.quantity),
              price: Number(orderItem.partPrice.replace(/,/g, '')),
              item_category: hierarchy.length > 1 ? hierarchy[0] : 'N/A',
              item_category2: hierarchy.length > 2 ? hierarchy[1] : 'N/A',
              item_category3: hierarchy.length > 3 ? hierarchy[2] : 'N/A',
              item_category4: hierarchy.length > 4 ? hierarchy[3] : 'N/A',
              item_category5: hierarchy.length > 5 ? hierarchy[4] : 'N/A',
              item_brand: 'Parker',
              item_variant: orderItem.partNumber,
              coupon: 'N/A',
              discount: 'N/A',
              content_owner: orderItem.contentOwner
            });
            //    totalQuantity = totalQuantity + Number(orderItem.quantity);
          });
        }
      }

      addToCartDataLayer(sessionDataItems, totalPrice, items);

      //setImageUrl(result.data.imageURL);
      await create(
        dataItems,
        sessionDataItems,
        sessionId,
        partNum,
        uniquePartIdentifier
      );
      setAddToCardData(result.data);
      console.log(result.data);
    }
  };

  const createXMLReference = async (
    attributes,
    partName,
    partNumber,
    divisionId
  ) => {
    let sellingDivId;
    if (sessionDataItems?.countryId != '687PDC')
      sellingDivId = sessionDataItems.countryId;
    else sellingDivId = divisionId;
    let json_format = {
      attributes: attributes,
      partName: partName,
      partNumber: partNumber,
      divisionId: divisionId,
      sellingDivId: sellingDivId,
      productId: sessionDataItems?.productId
    };
    let key = await HttpService.postByObject('cart', json_format)
      .then(res => {
        return res.data;
      })
      .catch(err => console.log(err));
    return key;
  };

  const createBom = async sessionData => {
    let uniquePartNumber = localUniquePartIdentifier;
    var uniqueCode = uniqueCodeTemplate(dataItems);
    if (uniqueCode != '') {
      uniquePartNumber = await getUniquePartIdentifierforManifold(
        dataItems,
        sessionData
      );
      if (dataItems.isManifoldProduct)
        sessionData.partNumber = uniquePartNumber;
      else sessionData.partNumber = getPartNumberString(dataItems);
      handleUniquePartNumber(uniquePartNumber);
      localUniquePartIdentifier = uniquePartNumber;
    }

    let sessionId = await postSessionData(sessionDataItems);
    var refId = await create(
      dataItems,
      sessionDataItems,
      sessionId,
      sessionData.partNumber,
      localUniquePartIdentifier
    );
    return {
      refId: refId,
      sessionId: sessionId,
      partNumber: sessionData.partNumber
    };
  };

  const onWhereToBuyClick = async () => {
    props.isLoading(true);

    if (sessionDataItems.contentSyndication != null) {
      postContentSyndication(false);
    }

    whereToBuyDataLayer(sessionDataItems, getPartNumberString(dataItems));
    if (dataItems.isNormalProduct) {
      sessionDataItems.partNumber = getPartNumberString(dataItems);
    } else {
      var OrderCodeComplete = dataItems?.infoGroup?.orderCodeComplete?.value;
      sessionDataItems.partNumber = OrderCodeComplete.split('~')[0];
    }

    sessionDataItems.bomRefId = null;
    await createBom(sessionDataItems);

    props.isLoading(false);
    let url = whereToBuyUrl();
    window.open(url);
  };

  const whereToBuyUrl = () => {
    var productId = sessionDataItems?.productId;
    return `${
      config.whereToBuyUrl
    }/${sessionDataItems?.countryCode.toLowerCase()}/${
      sessionDataItems?.language
    }/find-distributor/distributors?brd=find-a-part&app=wtb&part_series_id=${productId}&part_search_type=S&catName=${
      sessionDataItems?.seriesName
    }&divid=${sessionDataItems?.manufacturingDivision}&navOwner=${
      sessionDataItems?.countryId
    }`;
  };

  const isVE = () => {
    if (
      sessionDataItems?.landingPageUrl != null &&
      sessionDataItems?.landingPageUrl != '' &&
      sessionDataItems?.option == '97'
    )
      return true;
    else return false;
  };

  const handleCancelReturn = () => {
    props.isLoading(true);
    window.open(sessionDataItems.returnUrl, '_self');
  };

  const handleSaveProceed = async () => {
    props.isLoading(true);
    let result = await createSummarySession();

    if (dataItems.isManifoldProduct) {
      let manifoldPartNumbers = await createPartNumberListofSegments(
        dataItems,
        sessionDataItems,
        activeTab
      );
      sessionDataItems.manifoldPartNumbers = manifoldPartNumbers;
    }

    sessionDataItems.summaryUrl =
      window.location.origin + '/summary/print?session=' + result.sessionId;
    let sessionId = await postSessionData(sessionDataItems);
    window.open(
      sessionDataItems.landingPageUrl + '&ConfiguratorSessionId=' + sessionId,
      '_self'
    );
  };

  const createSummarySession = async () => {
    var stepNames = [];
    if (dataItems?.isManifoldProduct) {
      var uniqueCode = uniqueCodeTemplate(dataItems);
      if (uniqueCode != '') {
        let uniquePartNumber = await getUniquePartIdentifierforManifold(
          dataItems,
          sessionDataItems
        );
        localUniquePartIdentifier = uniquePartNumber;
        handleUniquePartNumber(uniquePartNumber);
        sessionDataItems.partNumber = uniquePartNumber;
      }
      for (var step of dataItems.tactonModel.steps.filter(
        x => x.available == true
      )) {
        stepNames.push(step.name);
      }
    } else if (dataItems?.isNormalProduct) {
      var uniqueCode = uniqueCodeTemplate(dataItems);
      if (uniqueCode != '') {
        let uniquePartNumber = await getUniquePartIdentifierforManifold(
          dataItems,
          sessionDataItems
        );
        localUniquePartIdentifier = uniquePartNumber;
        handleUniquePartNumber(uniquePartNumber);
      }
      sessionDataItems.partNumber = getPartNumberString(dataItems);
      stepNames.push(stepName());
    } else {
      sessionDataItems.partNumber =
        dataItems?.infoGroup?.orderCodeComplete?.value;
      stepNames.push(stepName());
      //store.sessionData.partNumber = await tactonService.getOrderCodeComplete();
    }
    sessionDataItems.configState = getConfigState();
    sessionDataItems.stepNames = stepNames;
    sessionDataItems.bomRefId = null;
    let session_id = await postSessionData(sessionDataItems);
    return {
      sessionId: session_id,
      partNumber: sessionDataItems.partNumber
    };
  };

  const stepName = () => {
    let currentStep = getCurrentStep();

    if (!currentStep) return '';

    return currentStep[0].name;
  };

  const getConfigState = () => {
    return dataItems.tactonModel.configState;
  };

  const getUpdatedCadPartNumber = (uri, key, value) => {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      return uri + separator + key + '=' + value;
    }
  };

  const handleSummaryClick = async () => {
    try {
      props.isLoading(true);
      if (sessionDataItems.contentSyndication != null) {
        postContentSyndication(false);
      }
      viewSummarySheetDataLayer(
        sessionDataItems,
        getPartNumberString(dataItems)
      );

      if (dataItems.isManifoldProduct) {
        if (!orderSummarySteps) {
          let steps = await getManifoldOrderSummarySteps(
            dataItems,
            sessionDataItems,
            activeTab
          );
          setOrderSummarySteps(steps);
        }
      }
      let result = await createSummarySession();
      await create(
        dataItems,
        sessionDataItems,
        result.sessionId,
        result.partNumber,
        localUniquePartIdentifier
      );
      setDisplayPartNumber(result.partNumber);
      props.isLoading(false);
      setOpenModal(true);
    } catch (error) {
      console.log(error);
      props.isLoading(false);
    }
  };

  const getCurrentStep = () => {
    return dataItems?.tactonModel?.steps?.filter(x => x.current);
  };

  const showPartSection = () => {
    let currentStep = getCurrentStep();

    if (!currentStep || currentStep.length == 0) return false;

    if (currentStep[0].name == 'product_selection') return false;
    else return true;
  };

  const isQuote = () => {
    if (sessionDataItems?.contentSyndication != null) {
      return sessionDataItems?.contentSyndication?.requestquote?.visible;
    } else {
      return sessionDataItems?.cartType == CartType.Quote;
    }
  };

  const isShop = () => {
    if (localUniquePartIdentifier?.includes('REF-PDN')) return false;
    return (
      (sessionDataItems?.cartType == CartType.Shop &&
        sessionDataItems?.configModel != 'GlobalCore') ||
      sessionDataItems?.option == '100'
    );
  };

  const isSummary = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems?.contentSyndication.summary_visible;
  };

  const isWhereToBuy = () => {
    if (sessionDataItems?.option == '101') return false;
    if (sessionDataItems?.contentSyndication == null) {
      return sessionDataItems.phConnect == null
        ? true
        : sessionDataItems.phConnect.WhereToBuy;
    }
    return sessionDataItems?.contentSyndication.wheretobuy_visible;
  };

  const isContactus = () => {
    if (sessionDataItems?.contentSyndication == null) {
      return true;
    }
    return sessionDataItems?.contentSyndication.contactus.visible;
  };

  const hasPrice = () => {
    if (priceLeadTime?.priceAmt > 0 || hoseAssemblyPrice?.offerPrice > 0) {
      return true;
    } else {
      return false;
    }
  };

  const price = () => {
    if (priceLeadTime == null && hoseAssemblyPrice == null) return '';

    var quantity = parseInt(txt_quantity);
    if (Number.isNaN(quantity)) quantity = 1;

    quantity = Math.max(1, quantity);
    var currencySymbol;
    var price;
    if (priceLeadTime?.priceAmt > 0) {
      currencySymbol = priceLeadTime?.currencySymbol;
      price = priceLeadTime?.priceAmt;
    } else if (hoseAssemblyPrice?.offerPrice > 0) {
      if (
        hoseAssemblyPrice?.fitting1NetPrice == 0 ||
        hoseAssemblyPrice?.fitting2NetPrice == 0
      ) {
        return 'Price: N/A';
      }

      currencySymbol = '$';
      price = hoseAssemblyPrice?.offerPrice;
    }
    price = price * quantity;
    if (sessionDataItems.contentSyndication != null)
      postContentSyndication(false);
    return (
      currencySymbol +
      price.toLocaleString(undefined, { minimumFractionDigits: 2 })
    );
  };

  const handleQuantityChange = e => {
    let quantity = e.target.value;
    if (quantity < 1) quantity = 1;
    set_txt_quantity(quantity);
  };

  const handleAddToCart = async () => {
    //Create new session Id
    props.isLoading(true);

    if (dataItems.isNormalProduct) {
      sessionDataItems.partNumber = getPartNumberString(dataItems);
    } else {
      var OrderCodeComplete = dataItems?.infoGroup?.orderCodeComplete?.value;
      sessionDataItems.partNumber = OrderCodeComplete.split('~')[0];
    }

    sessionDataItems.bomRefId = null;
    var result = await createBom(sessionDataItems);
    if (localUniquePartIdentifier?.includes('REF-PDN')) {
      setOpenTextModal(true);
      setModalContent(
        'This is an Unassembled manifold. See the Aggregate BOM section of the Summary Sheet for the list of components to order.'
      );
      props.isLoading(false);
    } else {
      await addToCart(result.partNumber, result.sessionId);
      if (sessionDataItems.contentSyndication != null) {
        postContentSyndication(true);
      }
    }
  };

  const allPartNumbers = () => {
    var currentStep = getStep(dataItems);
    var parts = [];
    var partMem = currentStep.rootGroup.members.filter(
      x => x.properties && x.properties['info_group'] == 'yes'
    );
    if (partMem.length > 0)
      parts = partMem[0].members.filter(
        x =>
          x.properties['ph_order_code_field'] == 'yes' &&
          x.properties['hidden'] == 'no'
      );
    return parts;
  };

  const getImageUrl = () => {
    if (addToCartData) return addToCartData.imageURL;
    else return '';
  };

  const getName = () => {
    if (addToCartData) return addToCartData.name;
    else return '';
  };

  const getQuantity = () => {
    if (addToCartData != null) return addToCartData.quantity;
    else return '';
  };

  const getPrice = () => {
    if (addToCartData != null) return addToCartData.price;
    else return '';
  };

  const getShowWarningSign = () => {
    if (addToCartData != null) return addToCartData.showSafetyWarning;
    else return true;
  };

  const getUnitofMeasure = () => {
    if (addToCartData != null) return addToCartData.unitOfMeasure;
    else return '';
  };

  const getTotalProductPrice = () => {
    if (addToCartData != null) return addToCartData.totalProductPrice;
    else return '';
  };

  const getTotalItems = () => {
    if (addToCartData != null) return addToCartData.totalItems;
    else return '';
  };

  const getViewCartUrl = () => {
    if (addToCartData != null) {
      window.open(
        decodeURIComponent(addToCartData.checkoutRedesignViewCartLink),
        '_self'
      );
    }
  };
  const getCheckoutUrl = () => {
    if (addToCartData != null) {
      window.open(
        decodeURIComponent(addToCartData.checkoutRedesignCheckoutLink),
        '_self'
      );
    }
  };
  const getViewProductUrl = () => {
    if (addToCartData != null) {
      window.open(
        'https://phtest.parker.com' + addToCartData.productURL,
        '_self'
      );
    }
  };
  const getContinueShoppingUrl = () => {
    if (addToCartData != null) {
      window.open('https://phtest.parker.com/us/en/category', '_self');
    }
  };

  const handleTextModalClose = () => {
    setOpenTextModal(false);
  };

  const postContentSyndication = fromPrice => {
    var configdata = getContentSyndicationData(
      sessionDataItems,
      dataItems,
      localUniquePartIdentifier
    );
    if (fromPrice) console.log(configdata);

    window.parent.postMessage(
      {
        econfigdata: configdata
      },
      '*' //or "www.parentpage.com"
    );
  };

  const isSendQuery = () => {
    if (sessionDataItems.contentSyndication == null) {
      return false;
    }
    return sessionDataItems.contentSyndication.send_query;
  };

  const handleSendQuery = () => {
    if (sessionDataItems.contentSyndication != null) {
      postContentSyndication(true);
    }
  };

  const handleRequestQuoteClose = () => {
    setShowRequestQuote(false);
  };

  const getEnvironment = () => {
    let url = window.location.href;
    let env;
    if (url.includes('localhost') || url.includes('dev')) env = 'dev_';
    else if (url.includes('test')) env = 'test_';
    else if (url.includes('preview')) env = 'stage_';
    else env = 'prod_';
    return env;
  };

  const getCookie = name => {
    const cookieArr = document.cookie.split('; ');
    for (let cookie of cookieArr) {
      let cookieData = cookie.split('=');
      if (cookieData && cookieData.length > 0) {
        if (cookieData[0] === name) {
          return cookieData[1];
        }
      }
    }
    return '';
  };

  const setCookie = (name, value) => {
    document.cookie = name + '=' + value + ';domain=.parker.com;path=/';
  };

  // const handleShowChat = () => {
  //   let chatCountries = LiveChatCountries;

  //   if (
  //     chatCountries?.CountryList?.filter(
  //       x =>
  //         x.CountryID?.toLowerCase() ==
  //         sessionDataItems?.countryId?.toLowerCase()
  //     ).length > 0
  //   )
  //     return true;
  //   else return false;
  // };

  return (
    <>
      <Grid>
        {hasPrice() ? (
          <Grid container>
            <Grid item xs={12}>
              <label className="buy-price">{price()}</label>
            </Grid>
          </Grid>
        ) : (
          ''
        )}
        {isVE() ? (
          <Grid container className="quantity">
            <Grid item xs={12}>
              <Typography className="normal-header">
                Virtual Engineering
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <RoundButton
                name="Save and Proceed"
                onClick={() => handleSaveProceed()}
              />
            </Grid>
            <Grid item xs={12}>
              <RoundButton
                name="Cancel and Return"
                onClick={() => handleCancelReturn()}
              />
            </Grid>
          </Grid>
        ) : (
          ''
        )}

        {(isQuote() || isShop()) && (
          <Grid container className="quantity">
            <Grid item xs={6}>
              <Typography className="normal-header">
                {lang?.QUANTITY}
              </Typography>
            </Grid>
            <Grid item xs={props.chk != null ? 6 : 12}>
              <OutlinedInput
                type="number"
                value={txt_quantity}
                onChange={e => handleQuantityChange(e)}
                sx={{
                  // marginRight: props.chk != null ? '15px' : '',
                  // marginLeft: props.chk != null ? '-10px' : '',
                  width: props.chk != null ? '100%' : '92%',
                  margin: props.chk != null ? '0 15px 0 -10px' : '8px 0 0 12px',
                  '& input': {
                    padding: '7px 15px'
                  }
                }}
              />
            </Grid>
          </Grid>
        )}
        {showPartSection() && (
          <>
            <Grid>
              {isQuote() && (
                <RoundButton
                  name={lang?.REQUEST_QUOTE}
                  classname="yellow-button w-100"
                  onClick={() => handleRequestQuote()}
                />
              )}
              {isShop() && (
                <RoundButton
                  name={lang?.ADD_TO_CART}
                  classname="yellow-button w-100"
                  onClick={() => handleAddToCart()}
                />
              )}
              {isSummary() && (
                <RoundButton
                  name={lang?.VIEW_SUMMARY_SHEET}
                  onClick={() => handleSummaryClick()}
                />
              )}

              {isSendQuery() && (
                <RoundButton
                  name="Continue"
                  onClick={() => handleSendQuery()}
                />
              )}
              <hr />
            </Grid>
            {isWhereToBuy() && (
              <Grid>
                <Typography className="normal-header">
                  {lang?.FIND_A_DISTRIBUTOR}
                </Typography>

                <RoundButton
                  name={lang?.WHERE_TO_BUY}
                  onClick={() => onWhereToBuyClick()}
                />
                <hr />
              </Grid>
            )}
          </>
        )}
        {isContactus() && contactus && (
          <Grid>
            <Typography className="normal-header">
              {lang?.CONTACT_US}
            </Typography>

            <Typography className="normal-header mt-1">
              {contactus?.title}
            </Typography>

            <Typography className="font-size-13">
              {contactus?.name}
              {contactus?.address1 != undefined && contactus?.address1 != '' ? (
                <>{contactus?.address1}</>
              ) : (
                <></>
              )}
              {contactus?.address2 != undefined && contactus?.address2 != '' ? (
                <>{contactus?.address2}</>
              ) : (
                <></>
              )}
              {contactus?.address3 != undefined && contactus?.address3 != '' ? (
                <>{contactus?.address3}</>
              ) : (
                <></>
              )}
              {contactus?.cityaddress != undefined &&
              contactus?.cityaddress != '' ? (
                <>{contactus?.cityaddress}</>
              ) : (
                <></>
              )}
              {contactus?.country != undefined && contactus?.country != '' ? (
                <>{contactus?.country}</>
              ) : (
                <></>
              )}
            </Typography>
            <Grid container className="mt-1">
              <Grid className="contact-phone">
                {contactus?.phone ? (
                  <>
                    <Typography className="contact-phone-label">
                      {lang?.TELEPHONE}
                    </Typography>
                    {' ' + contactus?.phone}
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
            <Grid container>
              <Grid className="contact-phone">
                {contactus?.fax != undefined ? (
                  <>
                    <Typography className="contact-phone-label">
                      {lang?.FAX}
                    </Typography>
                    {contactus?.fax}
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
            {/* {handleShowChat() && <Chat config={config} />} */}

            <hr />
          </Grid>
        )}
      </Grid>

      <SummaryModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        contactus={contactus}
        dataItems={dataItems}
        sessionDataItems={sessionDataItems}
        lang={lang}
        displayPartNumber={displayPartNumber}
        orderSummarySteps={orderSummarySteps}
        uniquePartIdentifier={localUniquePartIdentifier}
      />
      {openCartModal && (
        <CartModal
          open={openCartModal}
          imageURL={getImageUrl()}
          name={getName()}
          partNumber={getPartNumberString(dataItems)}
          quantity={getQuantity()}
          price={getPrice()}
          showWarningSign={getShowWarningSign()}
          unitOfMeasure={getUnitofMeasure()}
          totalProductPrice={getTotalProductPrice()}
          totalItems={getTotalItems()}
          viewCartUrl={() => getViewCartUrl()}
          checkoutUrl={() => getCheckoutUrl()}
          viewProductUrl={() => getViewProductUrl()}
          continueShoppingUrl={() => getContinueShoppingUrl()}
          handleClose={() => setOpenCartModal(false)}
        />
      )}
      {openTextModal && (
        <TextModal
          open={openTextModal}
          content={modalContent}
          handleClose={() => handleTextModalClose()}
        />
      )}

      {showRequestQuote && (
        <RequestQuoteModal
          open={showRequestQuote}
          sessionDataItems={sessionDataItems}
          quantity={txt_quantity}
          cartResponse={cartResponse}
          miniQuoteCartResponse={miniQuoteCartResponse}
          productImage={productImage}
          handleClose={handleRequestQuoteClose}
        />
      )}
    </>
  );
};
export default RightSection;
